import { render } from "./BoardListComponent.vue?vue&type=template&id=75eca767&scoped=true"
import script from "./BoardListComponent.vue?vue&type=script&lang=js"
export * from "./BoardListComponent.vue?vue&type=script&lang=js"

import "./BoardListComponent.vue?vue&type=style&index=0&id=75eca767&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75eca767"]])

export default __exports__